import React from 'react';
import styled from 'styled-components';

import imgPresentacion from '../../images/LogoFondoVerde.jpg';
import imgPresentacion1 from '../../images/todo/PresentacionPaginaWeb.jpg';
import imgPresentacion2 from '../../images/todo/PresentacionPaginaWeb2.jpg';
import imgPresentacion3 from '../../images/todo/4pasos.jpg';

const DivBodyInicio1 = () => {
    return(
        <DivBodyInicio1CSS>
        <h2>Club Ecoturístico Flor del Guaviare</h2>
        <DivPresentacionBox>
        <DivPresentacionImagesCSS>
            <div className="divPresentacionSlider">
                <PresentacionSlider1>
                <img src={imgPresentacion} alt="/" />
                </PresentacionSlider1>
                <PresentacionSlider1>
                <img src={imgPresentacion1} alt="/"/>
                </PresentacionSlider1>
                <PresentacionSlider1>
                <img src={imgPresentacion2} alt="/"/>
                </PresentacionSlider1>
                <PresentacionSlider1>
                <img src={imgPresentacion3} alt="/"/>
                </PresentacionSlider1>
            </div>
        </DivPresentacionImagesCSS>
        <div className="textoDiv1">
            <h3>
                INVIERTABIEN S.A.S <br></br>te Ofrece la Oportunidad de  invertir en un  negocio rentable que además de darte diversión, 
                Aventura y Naturaleza acampando en GLAMPING con tu Familia, puedas también generar ingresos e incrementar tu patrimonio 
                alquilando tu parcela a familiares, amigos y/o terceros nacionales y del extranjero.
            </h3>
        </div>
        </DivPresentacionBox> 
    </DivBodyInicio1CSS>
    )
}
export default DivBodyInicio1;

const DivPresentacionBox = styled.div`
    height: 78%;
    width: 100%;
    display: flex;
    @media(max-width: 1200px) {
        height:80%;
    }
    @media(max-width: 1024px) {
        height:83%;
    }
    @media(max-width: 768px) {
        height:85%;
        display: block;
    }
    @media(max-width: 480px) {
        height:87%;
        display: block;
    }
    @media(max-width: 320px) {
        height:89%;
        display: block;
    }
`;

const DivBodyInicio1CSS = styled.div`
  width: 100%;
  height:44%;
  margin-bottom: 20%;
  background-color: #003333;
  display:block;
  @media(max-width: 768px) {
    height: 60%;
    margin-bottom: 25%;
  }
  @media(max-width: 480px) {
    height: 60%;
    margin-bottom: 25%;
  }
  @media(max-width: 320px) {
    height: 60%;
    margin-bottom: 25%;
  }
  h2 {
    margin-bottom: 0%;
    widht: 100%;
    height: 9%;
    font-size:40px;
    font-family: widen latin;
    color: white;
    margin-top: 4%;
    @media(max-width: 320px) {
      font-size:19px;
      margin-top: 2%;
    }
    @media(max-width: 480px) {
      font-size:24px;
    }
    @media(max-width: 768px) {
      font-size:30px;
      margin-top: 3%;
    }
  }
  .textoDiv1 {
      position: relative;
      top: 0%;
      left: 10%;
      width: 48%;
      height: 85%;
      margin: 2%;
      box-shadow: 2px 4px 4px 2px ;
      @media(max-width: 1200px) {
        top:4%;
        left: 2%;
        width: 50%;
        height: 85%;
      }
      @media(max-width: 1024px) {
        top:4%;
        left: 2%;
        width: 90%;
        height: 85%;
      }
      @media(max-width: 768px) {
        top:4%;
        left: 2%;
        width: 90%;
        height: 27%;
      }
      @media(max-width: 665px) {
        top:5%;
        left: 2%;
        width: 90%;
        height: 30%;
      }
      @media(max-width: 540px) {
          top:7%;
          left: 2%;
          width: 90%;
          height: 37%;
      }
      @media(max-width: 480px) {
          top:7%;
          left: 2%;
          width: 90%;
          height: 41%;
      }
      @media(max-width: 320px) {
          top:6%;
          left: 2%;
          width: 90%;
          height: 41%;
      }
  }
  .textoDiv1 h3 {
      color: #fff;
      font-family: widen latin;
      font-size: 33px;
      @media(max-width: 1200px) {
        font-size: 28px;
      }
      @media(max-width: 1024px) {
        font-size: 28px;
      }
      @media(max-width: 768px) {
        font-size: 20px;
      }
      @media(max-width: 665px) {
        font-size: 20px;
      }
      @media(max-width: 540px) {
        font-size: 19px;
      }
      @media(max-width: 480px) {
        font-size: 18px;
      }
      @media(max-width: 380px) {
        font-size: 18px;
      }
      @media(max-width: 320px) {
        font-size: 18px;
      }
  }
`;

const DivPresentacionImagesCSS = styled.div`
  position: relative;
  top: 5%;
  width: 35%;
  height: 90%;
  left: 3%;
  margin:0%;
  overflow: hidden;
  @media(max-width: 1200px) {
    width:45%;
    left: 3%;
    top: 3%;
    height: 90%;
  }
  @media(max-width: 1024px) {
    width:45%;
    left: 3%;
    top: 3%;
    height: 90%;
  }
  @media(max-width: 768px) {
    width:80%;
    left: 10%;
    top: 3%;
    height: 68%;
  }
  @media(max-width: 665px) {
    width:80%;
    left: 8%;
    top: 3%;
    height: 65%;
  }
  @media(max-width: 540px) {
    width:90%;
    left: 5%;
    top: 3%;
    height: 55%;
  }
  @media(max-width: 480px) {
    width:90%;
    left: 4%;
    top: 5%;
    height: 50%;
  }
  @media(max-width: 320px) {
    width:90%;
    left: 3%;
    top: 5%;
    height: 50%;
  }
  .divPresentacionSlider {
    width: 400%;
    height: 100%;
    display: flex;
    animation: cambio 30s infinite alternate linear;
  }
  @keyframes cambio{
    0%{
      margin-left: 0%;
    }
    20% {
        margin-left: 0%;
    }
    25% {
        margin-left: -100%;
    }
    45% {
        margin-left: -100%;
    }
    50% {
        margin-left: -200%;
    }
    70% {
        margin-left: -200%;
    }
    75% {
        margin-left: -300%;
    }
    100% {
        margin-left: -300%;
    }
  }
`;

const PresentacionSlider1 = styled.div`
  width:25%;
  position: relative;
  height:100%;
  img {
    width:100%;
    position: relative;
    height:100%;
  }
`;

